<div #container class="scroll-container">
  <button
    #scrollHandleLeft
    class="scroll-container-button scroll-container-button-left border nordic-blue-900-border circle white-bg shadow ps-xxsmall"
    (click)="scrollLeft()"
    data-test-scroll-left
  >
    <fcom-icon class="is-small" name="chevron-left"></fcom-icon>
  </button>

  <button
    #scrollHandleRight
    class="scroll-container-button scroll-container-button-right border nordic-blue-900-border circle white-bg shadow ps-xxsmall"
    (click)="scrollRight()"
    data-test-scroll-right
  >
    <fcom-icon class="is-small" name="chevron-right"></fcom-icon>
  </button>

  <ng-content></ng-content>
</div>
